import { BACKEND_BASE_URL, BACKEND_KAMMERDIENER_PREFIX, getHeaderWithBearerAutorization } from "../../EivngCore"
import { fetchPunktemeldungen } from "./fetchPunktemeldungen"
import { isPreventTeilnahmedatumMeldung, istVorVeranstaltungsbeginn } from "../../components/TeilnehmerMelden/teilnahmedatum"
import { fetchVeranstaltungOnly } from "../veranstaltungen/actions"
import moment from 'moment';

export const  TEILNEHMER_MELDEN_REQUESTED = "TEILNEHMER_MELDEN_REQUESTED"
export const  REMOVE_ALL_SEIZED_TEILNEHMER = "REMOVE_ALL_SEIZED_TEILNEHMER"
export const  TEILNEHMER_MELDEN_COMPLETED = "TEILNEHMER_MELDEN_COMPLETED"
export const  TEILNEHMER_MELDEN_FAILED = "TEILNEHMER_MELDEN_FAILED"

export const  TEILNEHMER_MELDEN_PUSH_COMPLETED = "TEILNEHMER_MELDEN_PUSH_COMPLETED"

export function removeAllSeized(vnr, erfassteEFNs){
  return {type: REMOVE_ALL_SEIZED_TEILNEHMER, vnr, efns: erfassteEFNs}
}
export function meldeTeilnehmerStarted(vnr){
  return {type: TEILNEHMER_MELDEN_REQUESTED, vnr}
}
export function meldeTeilnehmerCompleted(vnr){
  return {type: TEILNEHMER_MELDEN_COMPLETED, vnr}
}
/**
 * Traegt die EFN mit, an der die Schleife haengengeblieben ist: bei 406/422 ist genau diese
 * Teilnahme der Grund, und sie steht danach weiter an erster Stelle - erneutes Melden liefe
 * ohne diesen Hinweis in dieselbe Ablehnung.
 */
export function meldeTeilnehmerFailed(vnr, status, efn){
  return {type: TEILNEHMER_MELDEN_FAILED, vnr, payload: status, efn}
}
/**
 * `gemeldet` ist der Stand, der tatsaechlich rausging. Der Reducer streicht die Teilnahme nur,
 * wenn im Store immer noch genau dieser Stand steht - wer eine Zeile *waehrend* ihres eigenen
 * Requests bearbeitet, verloere sie sonst: geloescht wurde bisher allein anhand der EFN, und
 * die Aenderung war damit weg, ohne je gemeldet worden zu sein.
 */
export function pushTeilnahmeCompleted(vnr, efn, gemeldet){
  return {type: TEILNEHMER_MELDEN_PUSH_COMPLETED, vnr, efn, gemeldet}
}

/**
 * Die fuenf Felder, die gemeldet werden - und damit auch die, an denen sich entscheidet, ob
 * eine Teilnahme noch dem gemeldeten Stand entspricht. Verglichen wird mit ===: ein
 * unveraenderter Eintrag traegt dieselben Werte, ein bearbeiteter kommt aus einem neuen
 * Reducer-Lauf. Ein falscher "veraendert"-Befund kostet einen erneuten Druck auf Melden
 * (die API ist auf EFN+VNR idempotent), ein falscher "unveraendert" kostet die Aenderung.
 */
export const MELDE_FELDER = ['efn', 'punkte_basis_flag', 'punkte_lernerfolg_flag',
  'punkte_referent', 'teilnahmedatum'];

export const istGemeldeterStand = (teilnahme, gemeldet) =>
  Boolean(teilnahme) && Boolean(gemeldet) && MELDE_FELDER.every(feld => teilnahme[feld] === gemeldet[feld]);

/**
 * Der Auftrag: was beim Bestaetigen dastand, feldweise festgehalten.
 *
 * Bewusst kein Spread des Teilnahme-Objekts - was hier nicht namentlich steht, geht nicht raus.
 * Vorher wurde das ganze Objekt gesendet und nur addedTimestamp einzeln geloescht; jedes neue
 * Feld im Store waere unbemerkt mit auf der Leitung gewesen, und das Backend weist Zusatzfelder
 * nicht ab. Die Felder entsprechen dem Schema teilnahmeMeldung der Veranstalter-API.
 *
 * **Warum die Werte und nicht nur die EFNs.** Die Schleife lief frueher in jeder Runde neu ueber
 * den Store. Wer nach dem Bestaetigen an einer noch wartenden Zeile Punkte oder Datum aendert,
 * meldete damit einen Stand, den er nie bestaetigt hat - der Dialog hatte "3 Teilnahmen melden"
 * gefragt, nicht "was auch immer gleich dasteht". Das hier ist trotzdem **keine zweite
 * Warteschlange**: der Auftrag lebt nur in dieser einen Funktion, wird nirgends gespeichert und
 * ueberlebt keinen Reload. Was noch offen ist, steht weiterhin allein in erfassteTeilnahmen.
 */
function bestaetigteMeldungen(state, vnr){
  const erfassteTeilnehmer = state.punkteMeldung.erfassteTeilnahmen[vnr]
  if(erfassteTeilnehmer === undefined || erfassteTeilnehmer === null) return []
  return Object.values(erfassteTeilnehmer).map(teilnahme => {
    const auftrag = {}
    MELDE_FELDER.forEach(feld => { auftrag[feld] = teilnahme[feld] })
    return auftrag
  })
}

/** Steht die Teilnahme ueberhaupt noch da? Waehrend der Uebertragung entfernt heisst: nicht melden. */
const istNochErfasst = (state, vnr, efn) =>
  Boolean((state.punkteMeldung.erfassteTeilnahmen[vnr] || {})[efn])
export  function meldeErfassteTeilnahmen(vnr) {
  return async (dispatch, getState) => {

    const veranstaltung = getState().veranstaltungen[vnr]
    // Vor dem ersten dispatch und vor jedem fetch: eine Meldung vor dem Beginn ist eine Planung,
    // keine Tatsache, und die Kammer weist die Punkte zurueck - stumm, denn der EIV antwortet mit
    // 200. Der gesperrte Knopf ist die Erklaerung, das hier die Zusage: die Regel haengt nicht an
    // einer Schaltflaeche.
    if(istVorVeranstaltungsbeginn(veranstaltung)) return;

    dispatch(meldeTeilnehmerStarted(vnr));
    console.debug('starte Übermittlung der Teilnehmermeldungen für VNR', vnr);

    const bearer = veranstaltung.bearer
    const suppressTeilnahmeDatum = isPreventTeilnahmedatumMeldung(veranstaltung)
    try{
      let counter = 0;
      const auftrag = bestaetigteMeldungen(getState(), vnr)
      for(const bestaetigt of auftrag){
        // Zwischenzeitlich von Hand entfernt - dann bleibt sie entfernt.
        if(!istNochErfasst(getState(), vnr, bestaetigt.efn)) continue;
        const teilnahme = {...bestaetigt}
        if(suppressTeilnahmeDatum) {
          teilnahme.teilnahmedatum = null
          console.log("Teilnahmedatum unterdrucken", teilnahme)
        }else{
          teilnahme.teilnahmedatum = moment(teilnahme.teilnahmedatum).toISOString();
        }
        const headers = getHeaderWithBearerAutorization(bearer);
        const response = await fetch(`${BACKEND_BASE_URL}${BACKEND_KAMMERDIENER_PREFIX}/fobi/veranstalter/push_teilnahme`,
        
        {
          method: 'POST',
          credentials: 'include',
          body: JSON.stringify(teilnahme),
          headers: headers
        });
        // Nicht jede Antwort ist JSON: der Server schickt bei 401 den nackten Text
        // "invalid token". Ein ungeschuetztes response.json() wirft dann **vor** dem switch,
        // der Abbruch landet im catch und verliert genau den Statuscode, an dem haengt, ob
        // Wiederholen ueberhaupt hilft. Massgeblich ist der Status, der Body ist Diagnose.
        const jsonData = await response.json().catch(() => null)
        console.log("Server responsed", response.status, jsonData)
        if(response.status === 200){
          dispatch(pushTeilnahmeCompleted(vnr, bestaetigt.efn, bestaetigt));
          counter++
          console.debug("melde Teilnahme", counter, bestaetigt.efn)
          continue;
        }
        dispatch(meldeTeilnehmerFailed(vnr, response.status, bestaetigt.efn));
        // 403: die Berechtigung kann zwischenzeitlich erneuert worden sein - Veranstaltung neu
        // holen, damit der naechste Versuch mit gueltigem Bearer laeuft.
        if(response.status === 403) dispatch(fetchVeranstaltungOnly(bearer));
        break;
      }
    }catch(e){
      console.error('Error during Teilnehmermeldung für VNR', vnr, e);
      dispatch(meldeTeilnehmerFailed(vnr));
    }finally{
      // Ins finally, nicht ans Ende des try: die Action heisst "Schleife beendet" und beendet
      // den Zustand "Uebertragung laeuft", an dem der Meldeknopf haengt. Stand sie im try, blieb
      // der Knopf nach einem Wurf (Netzabbruch) fuer immer gesperrt.
      dispatch(meldeTeilnehmerCompleted(vnr));
      dispatch(fetchPunktemeldungen(vnr, bearer))
    }
  
  }
}